/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2025 Rochester Software Associates (service@rocsoft.com)
 */

import SimpleTag from './simpleTag';

/**
 * Center tags
 * {center}Text to be centered{/center}
 */
export default new SimpleTag(
    'center',
    (key, contents) => {
        return (
            <div key={key} style={{ textAlign: 'center' }}>
                {contents}
            </div>
        );
    },
    (contents) => `\n${contents}\n`
);
